<template>
  <div class="container-page">
    <p class="title-inner">{{ id == 0 ? 'Создание' : 'Редактирование' }} вопроса</p>
    <div>
      <div class="row">
        <div class="form-group required col-2">
          <ComponentInput label="Номер вопроса" v-model="card.order" required type="number" />
        </div>
        <div class="form-group required">
          <ComponentInput
            label="Текст вопроса"
            v-model="card.questionText"
            placeholder="Введите текст вопроса"
            required
          />
        </div>
      </div>

      <div class="form-group required">
        <ComponentInput
          label="Ответ на вопрос"
          v-model="card.answer"
          placeholder="Введите текст ответа на вопрос"
          required
          type="textarea"
        />
      </div>

      <div class="form-group">
        <CheckboxInput v-model="card.isPublished" label="Вопрос опубликован" />
      </div>
    </div>
    <div class="mb-16">
      <ButtonComponent class="mr-8" mod="gradient-bg" @click="save">Сохранить</ButtonComponent>
      <ButtonComponent mod="border" @click="close">Отмена</ButtonComponent>
    </div>
  </div>
</template>

<script>
  import { useVuelidate } from '@vuelidate/core';

  import ButtonComponent from '@/common/components/redesigned/ButtonComponent.vue';
  import CheckboxInput from '@/common/components/redesigned/CheckboxInput.vue';
  import Constants from '@/common/constants';

  import ComponentInput from '../../../common/components/ComponentInput.vue';
  import Api from '../api/question';

  export default {
    name: 'QuestionCard',
    components: { CheckboxInput, ButtonComponent, ComponentInput },
    data() {
      return {
        id: this.$route.params.id,
        card: {
          id: 0,
        },
      };
    },
    created() {
      this.loadCard();
    },
    methods: {
      loadCard() {
        if (this.id > 0) {
          Api.find(this.id).then((response) => {
            this.card = response.data;
          });
        }
      },
      save() {
        this.v$.$touch();
        if (this.v$.$invalid) {
          Constants.alert.fire('Ошибка', 'Проверьте правильность заполнения полей', 'error');
          return;
        }
        Api.update(this.card)
          .then(() => {
            Constants.alert.fire('Сохранение', Constants.commonSuccess, 'success');
            if (this.card.id) {
              this.$router.push({ name: 'QuestionCard', params: { id: this.card.id, action: 'edit' } });
            } else {
              this.$router.push({ name: 'Questions' });
            }
          })
          .catch(() => {
            Constants.alert.fire('Сохранение', Constants.commonError, 'error');
          });
      },
      close() {
        this.$router.push({ name: 'Questions' });
      },
    },
    setup: () => ({ v$: useVuelidate() }),
    validations() {
      return {
        card: {},
      };
    },
  };
</script>

<style lang="scss" scoped>
  .stockTable {
    .catalog-icon {
      top: 18px;
    }
  }
</style>
